export default "__VITE_ASSET__B$THJ8ku__";